export class AysClinicSpecialEquipment {

    public static fromObj(obj: any): AysClinicSpecialEquipment {
        return new AysClinicSpecialEquipment(obj.key, obj.alwaysAvailable);
    }

    constructor(
        public key: string,
        public alwaysAvailable?: boolean
    ) {
    }

    public clone(): AysClinicSpecialEquipment {
      return new AysClinicSpecialEquipment(this.key, this.alwaysAvailable);
    }
}
